import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '../contexts/AuthContext';
import './Login.css';

const DEV_MODE = process.env.REACT_APP_DEV_MODE === 'true';

const Login = () => {
  const { loginWithRedirect, isLoading, isAuthenticated } = useAuth0();
  const navigate = useNavigate();

  // In dev mode or if already authenticated, redirect to home
  React.useEffect(() => {
    if (DEV_MODE || isAuthenticated) {
      navigate('/home');
    }
  }, [DEV_MODE, isAuthenticated, navigate]);

  if (isLoading) {
    return (
      <div className="login-container">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  // In dev mode, show brief message before redirect
  if (DEV_MODE) {
    return (
      <div className="login-container">
        <div className="loading-spinner"></div>
        <p style={{ marginTop: '1rem', color: '#666' }}>Dev mode - redirecting...</p>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">
            <img src="/AIquire.png" alt="[AI]Quire" className="login-logo-img" />
          </div>
          <h1 className="login-title">Welcome to [AI]Quire</h1>
          <p className="login-subtitle">
            AI-Powered Government Procurement Intelligence
          </p>
        </div>

        <button
          className="btn-primary login-button"
          onClick={() => loginWithRedirect()}
        >
          Sign In / Sign Up
        </button>

        <div className="login-features">
          <div className="feature-item">
            <span className="feature-check">✓</span>
            <span>19,000+ Government Tenders</span>
          </div>
          <div className="feature-item">
            <span className="feature-check">✓</span>
            <span>AI-Powered Search & Analysis</span>
          </div>
          <div className="feature-item">
            <span className="feature-check">✓</span>
            <span>Real-time Opportunity Tracking</span>
          </div>
        </div>
      </div>

      <div className="login-background">
        <div className="background-gradient"></div>
      </div>
    </div>
  );
};

export default Login;
